var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { ShowMoreEventTimesModalActions, ShowMoreEventTimesModalData } from './show.more.event.times.modal.provider';
var ShowMoreEventTimesModalComponent = /** @class */ (function (_super) {
    __extends(ShowMoreEventTimesModalComponent, _super);
    function ShowMoreEventTimesModalComponent(dialogRef, actions, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.data = Object.assign({}, data);
        return _this;
    }
    ShowMoreEventTimesModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    ShowMoreEventTimesModalComponent.prototype.confirm = function () {
        this.actions.confirm();
        this.dialogRef.close();
    };
    return ShowMoreEventTimesModalComponent;
}(BaseComponent));
export { ShowMoreEventTimesModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/show.more.event.times.modal/show.more.event.times.modal.component.ts.pre-build-optimizer.js